module.exports = __webpack_public_path__ + "img/core_fanyi.1e940b97.png";